import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { mergeMap } from 'rxjs/operators';
import { Bill, Currency_Rate, Store, User } from 'src/app/models/RestModels';
import { GetEmpty } from 'src/app/classes/Empties';
import { BillInfo } from 'src/app/models/models';
import { forkJoin } from 'rxjs';

interface CBillInfo extends BillInfo
{
	selected:boolean;
}

@Component({
  selector: 'app-list-provider-bills',
  templateUrl: './list-provider-bills.component.html',
  styleUrls: ['./list-provider-bills.component.css']
})
export class ListProviderBillsComponent extends BaseComponent implements OnInit
{
	provider:User = GetEmpty.user();
	cbill_info_list:CBillInfo[] = [];
	currency_rate_list:Currency_Rate[] = [];
	user_store:Store = GetEmpty.store();

	show_make_payment:boolean = false;
	selected_bill_info_list:BillInfo[] = [];

	toggle_all:boolean = true;

	total:number = 0;
	pending:number = 0;
	total_to_pay:number = 0;
	total_to_pay_currency_id:string = '';

	ngOnInit(): void
	{

		this.is_loading = true;

		this.subs.sink = this.route.paramMap
		.pipe
		(
			mergeMap((params) => {

				let provider_id = Number(params.get('id'));
				return forkJoin
				({
					provider: this.rest.user.get(provider_id),
					bill_info: this.rest.bill_info.search({ eq: {provider_user_id: provider_id, paid_status: 'PENDING'}, limit:99999}),
					currency_rate: this.rest.getCurrencyRates(),
					user_store: this.rest.store.get(this.rest.current_user.store_id),
				})
			}),
		)
		.subscribe({
			next: (response) => {

				this.setTitle('Compras de ' + response.provider.name);

				this.provider = response.provider;
				this.currency_rate_list = response.currency_rate.data;
				this.user_store = response.user_store;

				this.cbill_info_list = response.bill_info.data.map((bill_info:BillInfo) =>
				{
					return {...bill_info, selected:true};
				});

				this.cbill_info_list.forEach((bill_info:CBillInfo) =>
				{
					if( bill_info.selected )
					{
						this.total += (bill_info.bill.total / this.getExchangeRate(this.user_store.default_currency_id, bill_info.bill));

						this.pending += (bill_info.bill.total - bill_info.bill.amount_paid) / this.getExchangeRate(this.user_store.default_currency_id, bill_info.bill);
					}
				});

				this.calculateTotals();

				this.selected_bill_info_list = this.cbill_info_list.filter((bill_info:CBillInfo) => bill_info.selected);

				this.is_loading = false;
			},
			error: (error) => {
				this.showError(error);
			},
		})
	}

	getExchangeRate(currency_id:string, bill:Bill):number
	{
		if( bill.currency_id == currency_id )
			return 1;

		let default_currency_id = this.user_store.default_currency_id;

		let currency_rate = this.currency_rate_list.find((r:Currency_Rate)=>
		{
			if( r.store_id != bill.store_id )
				return false;

			if( bill.currency_id == default_currency_id )
			{
				return r.currency_id == currency_id;
			}

			return r.currency_id == bill.currency_id;
		});

		return default_currency_id == bill.currency_id
			? currency_rate.rate
			: 1/currency_rate.rate;
	}


	calculateTotals()
	{
		let reduce_currencies = (p,bi) =>
		{
			if( !p.includes(bi.bill.currency_id) )
			{
				p.push(bi.bill.currency_id);
			}

			return p;
		};

		let currencies_ids = this.cbill_info_list
			.filter(bi=>bi.selected)
			.reduce( reduce_currencies, [] );

		this.total_to_pay_currency_id = currencies_ids.length == 1 ? currencies_ids[0] : this.user_store.default_currency_id;
		this.total_to_pay = 0;

		this.cbill_info_list.forEach((bill_info:CBillInfo) =>
		{
			if( bill_info.selected )
			{
				this.total_to_pay += (bill_info.bill.total - bill_info.bill.amount_paid) / this.getExchangeRate(this.total_to_pay_currency_id, bill_info.bill);
			}
		});
	}

	someChecked():boolean
	{
		return !this.cbill_info_list.some(bill_info=>!bill_info.selected);
	}

	onToggleAll(evt:Event)
	{
		let input = evt.target as HTMLInputElement;
		let value = input.checked ? 1 : null;

		this.cbill_info_list.forEach((bill_info:CBillInfo) => bill_info.selected = value ? true : false);

		this.calculateTotals();
	}

	onToggleCheck(bill_info:CBillInfo)
	{
		bill_info.selected = !bill_info.selected;
		this.calculateTotals();
	}

	onPay()
	{
		this.selected_bill_info_list = this.cbill_info_list.filter((bill_info:CBillInfo) => bill_info.selected);

		if( this.selected_bill_info_list.length == 0)
		{
			this.showError('No hay ninguna orden seleccionada');
			return;
		}

		this.show_make_payment = true;
	}

	onPaymentDone()
	{
		this.show_make_payment = false;
		this.router.navigate(['/list-provider']);
	}
}
